import { render, staticRenderFns } from "./Remind.vue?vue&type=template&id=22f3d499&scoped=true&"
import script from "./Remind.vue?vue&type=script&lang=js&"
export * from "./Remind.vue?vue&type=script&lang=js&"
import style0 from "./Remind.vue?vue&type=style&index=0&id=22f3d499&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f3d499",
  null
  
)

export default component.exports